import { colors } from '@/utils/colors';
import { CheckoutTheme } from '@cashfreepayments/cashfree-js';

export const CASHFREE_MODE = 'production';

export const CASHFREE_THEME: CheckoutTheme = {
  primaryColor: colors.blue[500],
  secondaryColor: colors.blue[700],
  tertiaryColor: '#FFFFFF',
  primaryTextColor: '#000000',
  secondaryTextColor: '#4B5563',
};

export const REDIRECT_TARGET: '_blank' | '_self' | '_modal' = '_modal';
